<template>
  <div class="q-py-lg q-px-md bg-yellow-1 text-center">
    <div v-if="!done" class="text-body1 q-mb-md q-px-xl">
      <div v-if="platform.auth === null">
        <strong>Important:</strong>
        If {{ platform.name }} provided multiple .zip files to download
        or you require any assistance,
        <br>
        please click the "I Need Help" button below.
      </div>
      <div v-else>
        <strong>Important:</strong>
        If you require any assistance, please click the "I Need Help" button below.
      </div>
    </div>
    <request-support-btn
      v-if="!done"
      :platform="platform"
      :get-account-id="getAccountId"
      @done="done = true"
    />
    <message v-else type="positive" class="text-body1">
      Thank you for informing us that you need help.
      A member of our support team will contact you via email shortly.
    </message>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import Message from '@/components/message/Message.vue';
import { Platform } from '@/social/types';
import RequestSupportBtn from './RequestSupportBtn.vue';

interface Data {
  done: boolean
}

export default defineComponent({
  components: { Message, RequestSupportBtn },
  props: {
    platform: {
      type: Object as () => Platform,
      required: true,
    },
    getAccountId: {
      type: Function as PropType<() => Promise<number>>,
      required: true,
    },
  },
  data(): Data {
    return {
      done: false,
    };
  },
});
</script>
